import React from 'react';
import WhyPopover from './why_popover';

/*
 * PROD-7828 R5 — Final payable table, rendered in the backend's order from final_payable_view.
 * Values are to the paisa (D-3, A-23); the informational carry forward (D-7) is shown but not part of the
 * arithmetic. Payable = max(net, 0) is the payout (B1).
 * The adapter blanks every amount and explain on a stale month (F1). Each amount opens the
 * persisted month-line explain (D-8); months computed before r5 have none, so no popover.
 */
const FinalPayable = ({ lines, gst_registered }) => {
  if (!lines || !lines.length) {
    return <div className="tp-empty">No final payable computed for this month.</div>;
  }
  return (
    <div className="tp-card" style={{ maxWidth: 560 }}>
      <div className="tp-card-hd">
        <span className="tp-card-hd-title">Final payable</span>
        <span className="tp-card-hd-sub">
          Unrounded values; GST {gst_registered ? 'registered' : 'not applicable'}
        </span>
      </div>
      <table className="tp-fpt">
        <tbody>
          {lines.map((l) => (
            <tr
              key={l.key}
              className={`${l.is_total ? 'tp-fpt-total' : ''} ${
                l.is_informational ? 'tp-fpt-info' : ''
              }`}
            >
              <td>
                <span className="tp-fpt-sign">{l.sign}</span> {l.label}
                {l.is_informational ? (
                  <span className="tp-card-field-label"> (informational)</span>
                ) : null}
              </td>
              <td>
                <WhyPopover
                  detail={l.explain}
                  amount_node={<span className={l.tone}>{l.amount_text}</span>}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FinalPayable;
